import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import styles from './ForgetPassword.module.css';
import {
  ForgetPasswordElement,
  ForgetPasswordElementInterface,
} from '../ForgetPasswordElement';
import { MobileView } from '../mobile/ForgetPassword.mobile';

export const DesktopView = (): JSX.Element => {
  const forgetPasswordElement: ForgetPasswordElementInterface =
    ForgetPasswordElement();
  return (
    <React.Fragment>
      <Box className={styles.desktopMainPage}>
        <Box className={styles.desktopLeftImageFrameBox}>
          <Box className={styles.desktopLeftImage}>
            <img
              style={{ width: 'inherit' }}
              id="login-image"
              alt=""
              src="assets/login/login-image@1x.png"
            />
          </Box>
          <Box className={styles.desktopRightMainGroup}>
            <Box className={styles.desktopRightMainContainerBox}>
              <MobileView />
            </Box>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};
